export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
